// src/components/organisms/PayPalSection.js

import React, { useEffect, useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import PropTypes from "prop-types";

const PayPalSection = ({ onSuccess, clientId, planId }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  return (
    loaded && (
      <PayPalScriptProvider
        options={{
          clientId: clientId,
          vault: true,
          currency: "USD", // Set your desired currency
        }}
      >
        <PayPalButtons
          style={{ layout: "vertical", shape: "pill" }}
          createSubscription={(data, actions) => {
            return actions.subscription.create({
              plan_id: planId,
            });
          }}
          onApprove={(data, actions) => {
            console.log("Subscription data:", data);
            // Pass the entire data object to the onSuccess handler
            onSuccess(data);
          }}
          onError={(err) => {
            console.error("PayPal Subscription onError", err);
            // Optionally, handle errors by notifying the user
          }}
        />
      </PayPalScriptProvider>
    )
  );
};

PayPalSection.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  clientId: PropTypes.string.isRequired,
  planId: PropTypes.string.isRequired,
};

export default PayPalSection;
